import { Component, signal } from '@angular/core';
import { MatInputModule } from '@angular/material/input';
import { MatFormFieldModule } from '@angular/material/form-field';
import {
  FormControl,
  FormGroup,
  ReactiveFormsModule,
  Validators,
} from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { AuthService } from '../../services/auth.service';
import { MatSnackBar } from '@angular/material/snack-bar';
import { TokenService } from '../../services/token.service';
import { Router, RouterModule } from '@angular/router';
import { MatCardModule } from '@angular/material/card';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatIconModule } from '@angular/material/icon';
import { whitespaceValidator } from '../../validators/whitespace.validator';
import { CommonModule } from '@angular/common';

interface LoginForm {
  email: FormControl<string | null>;
  password: FormControl<string | null>;
}

@Component({
  selector: 'app-login-page',
  templateUrl: './login-page.component.html',
  styleUrl: './login-page.component.scss',
  standalone: true,
  imports: [
    ReactiveFormsModule,
    MatInputModule,
    MatFormFieldModule,
    MatButtonModule,
    MatCardModule,
    MatProgressBarModule,
    MatIconModule,
    RouterModule,
    CommonModule,
  ],
})
export class LoginPageComponent {
  loading: boolean = false;

  loginFormGroup = new FormGroup<LoginForm>({
    email: new FormControl(null, [Validators.required]),
    password: new FormControl(null, [
      Validators.required,
      whitespaceValidator(),
    ]),
  });

  constructor(
    private authService: AuthService,
    private snackbar: MatSnackBar,
    private tokenService: TokenService,
    private router: Router
  ) {}

  hide = signal(true);
  clickEvent(event: MouseEvent) {
    this.hide.set(!this.hide());
    event.stopPropagation();
  }

  login() {
    const email = this.loginFormGroup.controls.email.value ?? '';
    const password = this.loginFormGroup.controls.password.value ?? '';

    this.authService.login(email, password).subscribe({
      next: (tokens) => {
        this.tokenService.updateTokens(tokens).then(() => {
          this.authService.loggedIn = true;
          this.router.navigateByUrl('home');
        });
      },
      error: (res) => {
        this.snackbar.open(
          res.error.suggestedMessage ?? 'An error has occurred.',
          '',
          { duration: 7000 }
        );
      },
    });
  }
}
